var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"confirm"},[_c('div',{staticClass:"confirm__header"},[_vm._v("Please check your email")]),_c('div',{staticClass:"confirm__content"},[_vm._v(" We sent a link to set your new password by email. ")]),_c('b-button',{staticClass:"w-100",attrs:{"variant":"primary"},on:{"click":_vm.hideModal}},[_vm._v(" Got it! ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }